const futureTs = Math.round(new Date().getTime() / 1000) + 7 * 60 * 1000;
const currentTs = Math.round(new Date().getTime() / 1000);

const cognitoUser = {
  username: "",
  pool: {
    userPoolId: "",
    clientId: "",
    client: {
      endpoint: "",
      fetchOptions: {},
    },
    advancedSecurityDataCollectionFlag: true,
    storage: {},
  },
  Session: null,
  client: {
    endpoint: "",
    fetchOptions: {},
  },
  signInUserSession: {
    idToken: {
      jwtToken: "token",
      payload: {
        sub: "",
        email_verified: true,
        profile: "readwrite",
        iss: "",
        "cognito:username": "",
        given_name: "Empower",
        origin_jti: "",
        aud: "",
        event_id: "",
        token_use: "id",
        auth_time: currentTs,
        exp: futureTs,
        iat: currentTs,
        family_name: "Energy",
        jti: "",
        email: "feedback@empowerenergy.com.au",
      },
    },
    refreshToken: {
      token: "token",
    },
    accessToken: {
      jwtToken: "jwt",
      payload: {
        sub: "",
        iss: "",
        client_id: "",
        origin_jti: "",
        event_id: "",
        token_use: "access",
        scope: "aws.cognito.signin.user.admin",
        auth_time: currentTs,
        exp: futureTs,
        iat: currentTs,
        jti: "",
        username: "",
      },
    },
    clockDrift: -1,
  },
  authenticationFlowType: "USER_SRP_AUTH",
  storage: {},
  keyPrefix: "",
  userDataKey: "",
  attributes: {
    sub: "",
    email_verified: true,
    profile: "readwrite",
    given_name: "Empower",
    family_name: "Energy",
    email: "feedback@elektrobank.com.au",
  },
  preferredMFA: "NOMFA",
};

// eslint-disable-next-line no-unused-vars
export const login = (email, password) => {
  return cognitoUser;
};

export const currentSession = () => {
  return cognitoUser.signInUserSession;
};

export const mockCognitoUser = () => {
  return cognitoUser;
};
